/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespLocationsModuleItemList_componentModule = {
    readonly location: {
        readonly title: string | null;
        readonly description: string | null;
        readonly imageUrl: string | null;
        readonly imageHeight: string | null;
        readonly imageWidth: string | null;
        readonly items: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly title: string | null;
            readonly linkData: {
                readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
            };
        } | null> | null;
    } | null;
    readonly " $refType": "HpRespLocationsModuleItemList_componentModule";
};
export type HpRespLocationsModuleItemList_componentModule$data = HpRespLocationsModuleItemList_componentModule;
export type HpRespLocationsModuleItemList_componentModule$key = {
    readonly " $data"?: HpRespLocationsModuleItemList_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespLocationsModuleItemList_componentModule">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpRespLocationsModuleItemList_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Location",
      "kind": "LinkedField",
      "name": "location",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LocationItem",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cmsId",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "LinkData",
              "kind": "LinkedField",
              "name": "linkData",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SeoLink_linkData"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LocationsModule",
  "abstractKey": null
};
})();
(node as any).hash = '14fb47a7412d87f0be200a863c551452';
export default node;
